import React from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Grow from '@material-ui/core/Grow';

import { withStyles } from '@material-ui/core/styles';

import bannerImage from '../../../Resources/BannerImage.JPG';

const styles = theme => ({
    root: {
        height: '100%',
        maxWidth: '100vw'
    },
    image: {
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: 'cover',
        minHeight: '500px'
    },
    paper: {
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2)
    },
})

class BannerComponent extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                {this.props.data.length === 0 ?
                    <Grid container direction="row"
                    justifyContent="center">
                        <p>Loading...</p>
                    </Grid>
                    :


                    <Grid container component="main" className={classes.root}>
                        <Grid container direction="row"
                            justifyContent="flex-end" alignItems="flex-end"
                            item xs={12} sm={12}
                            className={classes.image}>

                            < Grow
                                in={this.props.view}
                                style={{ transformOrigin: '0 0 0' }}
                                {...(this.props.view ? { timeout: 500 } : {})}
                            >
                                <Grid item xs={12} md={6} lg={3} style={{ padding: '1rem', fontSize: '12px' }} zeroMinWidth>
                                    <Paper className={classes.paper}>
                                        <Grid container direction="row">
                                            <Grid item xs={4} sm={4}>
                                                <img src="http://hydrologywp.selfip.com/images/morning.png" alt="img" />
                                            </Grid>
                                            <Grid container direction="row" item xs={8} sm={8}>
                                                <Grid item xs={12} sm={12}>
                                                    <Typography variant="subtitle1">
                                                        {this.props.data[this.props.idx]['location']}
                                                    </Typography>
                                                </Grid>
                                                <br />
                                                <Grid item xs={6} sm={6}>
                                                    Rain (Current):
                                                </Grid>
                                                <Grid item xs={6} sm={6}>
                                                    {this.props.data[this.props.idx]['curr_rain']}
                                                </Grid>
                                                <Grid item xs={6} sm={6}>
                                                    Rain (Total mm):
                                                </Grid>
                                                <Grid item xs={6} sm={6}>
                                                    {this.props.data[this.props.idx]['total_rain']}
                                                </Grid>
                                                <Grid item xs={6} sm={6}>
                                                    Level:
                                                </Grid>
                                                <Grid item xs={6} sm={6}>
                                                    {this.props.data[this.props.idx]['level']}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grow>
                        </Grid>

                    </Grid>
                }
            </React.Fragment >
        )
    }
}

export default withStyles(styles, { withTheme: true })(BannerComponent);